import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { FuseConfigService } from '@fuse/services/config.service';

import { MatTableDataSource } from '@angular/material/table';


import { Router } from '@angular/router';
import { CookieService } from 'angular2-cookie';
import { EmpresasService } from 'app/services/empresas/empresas.service';
import { LoginService } from 'app/services/login/login.service';
import { MatMenuTrigger } from '@angular/material/menu';

declare var $: any;

@Component({
    selector: 'app-empresas',
    templateUrl: './empresas.component.html',
    styleUrls: ['./empresas.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class EmpresasComponent implements OnInit {
    @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;

    empresas = [];

    empresasList = [];

    dataSource;
    displayedColumns: string[] = ['empresas', 'nit', 'acciones'];

    searchdata;

    // * ids Local Storage
    userIdLS = localStorage.getItem('userId');
    userRoleIdLS = localStorage.getItem('userRoleId');

    constructor(
        private _fuseConfigService: FuseConfigService,
        private _router: Router,
        private _empresasService: EmpresasService,
        private _logInService: LoginService,
        private _cookie: CookieService
    ) {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: true,
                },
                toolbar: {
                    hidden: true,
                },
                footer: {
                    hidden: true,
                },
                sidepanel: {
                    hidden: true,
                },
            },
        };
        this.getEmpresas();
    }
    descendants: boolean;
    first: boolean;
    read: any;
    isViewQuery: boolean;
    selector: any;
    static?: boolean;

    ngOnInit(): void {
        if (this.userIdLS !== '') {
            // console.log(this.userIdLS);
        } else {
            // reedirigir a login
            this._router.navigate(['/pages/auth/login-2']);
        }
        this.getEmpresas();
    }

    getEmpresas = () => {
        this._empresasService.getEmpresasList().subscribe((response) => {
            this.empresas = [...response];
            this.empresasList = [...response];
            this.dataSource = new MatTableDataSource(this.empresasList);
            // console.log('this.empresas :>> ', this.empresas);
        });
    }

    getIdEmpresas = (idEmpresa) => {
        if (idEmpresa !== null) {
            // console.log('idEmpresa :>> ', idEmpresa);
            localStorage.setItem('idEmpresa', idEmpresa);
            this._router.navigate(['/erp/reportes']);
        }
    }

    doFilter = (value: string): any => {
        this.dataSource.filter = value.trim().toLocaleLowerCase();
    }

    searchData(): any {
        $(document).ready(() => {
            $('#myInput').keyup(() => {
                const nthis = this;
                // Show only matching TR, hide rest of them
                $.each($('#myTable tbody tr'), () => {
                    if (
                        $(this)
                            .text()
                            .toUpperCase()
                            .indexOf($(nthis).val().toUpperCase()) === -1
                    ) {
                        $(this).hide();
                    } else {
                        $(this).show();
                    }
                });
            });
        });
    }

    logOut(): any {
        this._logInService.logout(this.userIdLS).subscribe((res) => {
            // localStorage.removeItem('userId');
            // localStorage.removeItem('userRoleId');
            // localStorage.removeItem('idEmpresa');
            // localStorage.removeItem('userToken');
            // localStorage.clear();
            console.log('res :>> ', res);
            if (res) {
                this._cookie.put('Bearer_auth', '');
                localStorage.setItem('username', '');
                localStorage.setItem('userId', '');
                localStorage.setItem('userRoleId', '');
                localStorage.setItem('idEmpresa', '');
                localStorage.setItem('userToken', 'false');
                this._router.navigate(['/pages/auth/login-2']);
            }

            if (res.Error === 'Please authenticate') {
                this._router.navigate(['/pages/auth/login-2']);
            }
        });
    }
}
